import React from 'react';
import './NewsSection.css';
import greenBullet from '../../assets/images/green-bullet.svg';

const NewsSection = () => {
  // News data based on the latest content
  const allNewsItems = [
    {
      id: 1,
      title: "Mavis Tire Completes Acquisition of Midas from TBC Corporation",
      date: "Jun 16, 2025",
      excerpt: "WHITE PLAINS, N.Y.--(BUSINESS WIRE)--Mavis Tire Express Services Corp. (“Mavis”), a leading provider of automotive repair and maintenance services and one of the largest independent tire and service providers in North America.",
      category: "Acquisitions"
    },
    {
      id: 2,
      title: "Harbor Receives Majority Investment from BayPine to Drive Digital Innovation Across Legal Sector",
      date: "Jun 04, 2025",
      excerpt: "CHICAGO, June 4, 2025 – Harbor Global, LLC (“Harbor” or the “Company”), the preeminent provider of consulting and technology services to the legal industry, today announced that it has received a majority investment from BayPine.",
      category: "Investments"
    },
    {
      id: 3,
      title: "BayPine to Acquire CenExel",
      date: "Apr 14, 2025",
      excerpt: "BOSTON--(BUSINESS WIRE)--BayPine LP (“BayPine”), a private investment firm that drives digital transformation in market-leading businesses, today announced that it has entered into a definitive agreement to acquire CenExel Clinical Research.",
      category: "Acquisitions"
    },
    {
      id: 4,
      title: "What's All the Fuss About AI?",
      date: "Nov 21, 2024",
      excerpt: "Artificial intelligence has leapt into the public consciousness with a string of recent product announcements and relentless media coverage[1]. We have a slew of new launches from Nvidia, Alphabet (Google) & Meta (Facebook).",
      category: "Insights"
    },
    {
      id: 5,
      title: "BayPine appoints Migo Terjanian as partner and head of investor relations",
      date: "May 14, 2024",
      excerpt: "BOSTON – MAY 14, 2024 - BayPine LP (“BayPine”), a private investment firm that drives digital transformation in market-leading businesses, today announced the appointment of Migo Terjanian as a Partner and Head of Investor Relations.",
      category: "Company News"
    },
    {
      id: 6,
      title: "Investor Group Led by Arsenal, in Partnership with BayPine, Acquires POLYWOOD",
      date: "Mar 25, 2024",
      excerpt: "March 25, 2024 – New York, Boston & Syracuse, Indiana – An investor group led by Arsenal Capital Partners (“Arsenal”), a private equity firm that specializes in building technology-rich, market leading industrial growth and healthcare companies.",
      category: "Partnerships"
    },
    {
      id: 7,
      title: "BayPine Strengthens Leadership Team With Senior Operating Talent",
      date: "Nov 14, 2023",
      excerpt: "BayPine LP (“BayPine”), a private investment firm that drives digital transformation in market-leading businesses, today announced that it has strengthened its leadership team with two senior appointments.",
      category: "Company News"
    },
    {
      id: 8,
      title: "Mavis Tire Express Services Corp. to Acquire NTB and Tire Kingdom Businesses from TBC Corporation",
      date: "May 23, 2023",
      excerpt: "Palm Beach Gardens, FL and Millwood, NY – (May 22, 2023) – TBC Corporation (“TBC”), one of North America’s leading providers of mobility solutions, announced today that it has entered into an agreement to divest its company-owned.",
      category: "Acquisitions"
    },
    {
      id: 9,
      title: "Penn Foster Group Begins the Next Chapter of 130 Year History by Bringing Top Online Education and Career Training Brands Together Under a New Name",
      date: "Apr 17, 2023",
      excerpt: "SCRANTON, Pa, April 17, 2023 — Penn Foster, a leading provider of digital and data-driven learning solutions for high demand skills and jobs, has unveiled the new name that marks the next phase of its 130+ year history — Penn Foster Group.",
      category: "Portfolio News"
    },
    {
      id: 10,
      title: "BayPine Vice President Emily Osman Lawrie Named 2023 M&A Business Development Professional to Watch",
      date: "Feb 06, 2023",
      excerpt: "BayPine Vice President Emily Osman Lawrie was named a 2023 M&A Business Development Professional to Watch by Middle Market Growth, which recognized ten standout, up-and-coming professionals in each of the categories of private equity business development.",
      category: "Company News"
    }
  ];

  // State for pagination
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 6;
  
  // Calculate which items to display based on current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = allNewsItems.slice(indexOfFirstItem, indexOfLastItem);
  
  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <section className="news-section">
      <div className="container">
        <div className="news-header">
          <h2 className="section-label">
            <img src={greenBullet} alt="" className="bullet-image" />
            LATEST NEWS
          </h2>
          <h3 className="news-title">
            Stay Updated with BayPine
          </h3>
          <p className="news-subtitle">
            Discover the latest news, announcements, and insights from BayPine and our portfolio companies.
          </p>
        </div>

        {/* <div className="news-filter">
          <button className="filter-button active">All</button>
          <button className="filter-button">Acquisitions</button>
          <button className="filter-button">Investments</button>
          <button className="filter-button">Partnerships</button>
          <button className="filter-button">Company News</button>
        </div> */}

        <div className="news-grid">
          {currentItems.map(item => (
            <div className="news-card" key={item.id}>
              <div className="news-card-content">
                <span className="news-category">{item.category}</span>
                <span className="news-date">{item.date}</span>
                <h4 className="news-card-title">{item.title}</h4>
                <p className="news-excerpt">{item.excerpt}</p>
                <a href={`/news/${item.id}`} className="news-link">
                  READ MORE
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.7387 12.6259L13.4506 17.0037C13.2898 17.1679 13.0754 17.25 12.861 17.25C12.6198 17.25 12.4054 17.1679 12.2446 17.0037C11.8961 16.6754 11.8961 16.1008 12.2446 15.7725L15.0586 12.8721H6.85762C6.37521 12.8721 6 12.4891 6 11.9966C6 11.5314 6.37521 11.121 6.85762 11.121H15.0586L12.2446 8.24805C11.8961 7.91971 11.8961 7.34511 12.2446 7.01678C12.5662 6.66107 13.129 6.66107 13.4506 7.01678L17.7387 11.3946C18.0871 11.723 18.0871 12.2976 17.7387 12.6259Z" fill="currentColor"/>
                  </svg>
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="news-pagination">
          <button 
            className={`pagination-button ${currentPage === 1 ? 'active' : ''}`}
            onClick={() => paginate(1)}
          >
            1
          </button>
          <button 
            className={`pagination-button ${currentPage === 2 ? 'active' : ''}`}
            onClick={() => paginate(2)}
          >
            2
          </button>
          {currentPage === 1 && (
            <button className="pagination-button next" onClick={() => paginate(2)}>
              Next
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.7387 12.6259L13.4506 17.0037C13.2898 17.1679 13.0754 17.25 12.861 17.25C12.6198 17.25 12.4054 17.1679 12.2446 17.0037C11.8961 16.6754 11.8961 16.1008 12.2446 15.7725L15.0586 12.8721H6.85762C6.37521 12.8721 6 12.4891 6 11.9966C6 11.5314 6.37521 11.121 6.85762 11.121H15.0586L12.2446 8.24805C11.8961 7.91971 11.8961 7.34511 12.2446 7.01678C12.5662 6.66107 13.129 6.66107 13.4506 7.01678L17.7387 11.3946C18.0871 11.723 18.0871 12.2976 17.7387 12.6259Z" fill="currentColor"/>
              </svg>
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
